(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const icons = {
    description: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h9l3 3v15H6z"/><path d="M15 3v4h4M9 11h6M9 15h6M9 19h4"/></svg>',
    why: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9z"/></svg>',
    specifications: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m4 17 13-13 3 3L7 20 4 20z"/><path d="m12 9 3 3M9 12l3 3M6 15l3 3"/></svg>',
    faq: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9.6 9a2.5 2.5 0 1 1 4.5 1.5c-1.1 1.2-2.1 1.6-2.1 3.2M12 17h.01"/></svg>',
    shipping: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v10H3zM14 9h4l3 4v3h-7z"/><circle cx="8" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>',
    payments: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 10h18M7 15h3"/></svg>',
    caret: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>'
  };

  const normalize = (value) => value
    .toLocaleLowerCase('es-CL')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const isHeading = (node) => node.matches('h1, h2, h3, h4, h5, h6') || (node.matches('p, div') && node.children.length === 1 && node.firstElementChild?.matches('strong, b'));

  const categoryFromHeading = (text) => {
    const value = normalize(text);
    if (!value || /^[—\-–_\s]+$/.test(text.trim())) return 'skip';
    if (value.includes('por que elegir') || value.includes('caracteristicas principales')) return 'why';
    if (value.startsWith('especificaciones') || value.startsWith('ficha tecnica')) return 'specifications';
    if (value.startsWith('preguntas frecuentes')) return 'faq';
    if (value.includes('consejos de uso')) return 'why-tips';
    if (value.includes('envio') || value.includes('metodos de pago') || value.includes('medios de pago')) return 'skip';
    return null;
  };

  const moveNodes = (nodes, destination) => nodes.forEach((node) => destination.append(node));

  const createAccordion = ({ key, title, open = false, card = false }) => {
    const details = document.createElement('details');
    details.className = `zhu-product-accordion${card ? ' zhu-product-details__card' : ''}`;
    details.open = open;
    const bodyClass = key === 'specifications' ? ' zhu-product-specifications' : key === 'faq' ? ' zhu-product-faq' : '';
    details.innerHTML = `<summary><span class="zhu-product-accordion__icon">${icons[key]}</span><span class="zhu-product-accordion__title">${title}</span><span class="zhu-product-accordion__caret">${icons.caret}</span></summary><div class="zhu-product-accordion__body"><div class="zhu-product-accordion__content${bodyClass}"></div></div>`;
    return { details, content: details.querySelector('.zhu-product-accordion__content') };
  };

  const createDescription = (nodes) => {
    const accordion = createAccordion({ key: 'description', title: 'Descripción', open: true, card: true });
    const copy = document.createElement('div');
    copy.className = 'zhu-product-description__copy';
    moveNodes(nodes, copy);
    accordion.content.append(copy);

    requestAnimationFrame(() => {
      const compactHeight = 132;
      if (copy.scrollHeight <= compactHeight + 2) return;

      copy.classList.add('is-truncated');
      const button = document.createElement('button');
      button.className = 'zhu-product-description__toggle';
      button.type = 'button';
      button.innerHTML = `<span>Mostrar más</span>${icons.caret}`;
      button.addEventListener('click', () => {
        const expanded = button.classList.toggle('is-expanded');
        copy.classList.toggle('is-expanded', expanded);
        button.querySelector('span').textContent = expanded ? 'Mostrar menos' : 'Mostrar más';
      });
      accordion.content.append(button);
    });

    return accordion.details;
  };

  const createFaq = (nodes) => {
    const accordion = createAccordion({ key: 'faq', title: 'Preguntas frecuentes' });
    let currentQuestion;
    let questionCount = 0;

    nodes.forEach((node) => {
      const text = node.textContent.trim();
      const questionHeading = node.matches('h3, h4, h5, h6') || (isHeading(node) && /^q\d+\s*:/i.test(text));
      if (!questionHeading) {
        (currentQuestion?.querySelector('.zhu-product-faq__answer') || accordion.content).append(node);
        return;
      }

      currentQuestion = document.createElement('details');
      currentQuestion.className = 'zhu-product-faq__item';
      currentQuestion.innerHTML = `<summary><span class="zhu-product-faq__question"></span>${icons.caret}</summary><div class="zhu-product-faq__answer"></div>`;
      currentQuestion.querySelector('.zhu-product-faq__question').textContent = text.replace(/^q\d+\s*:\s*/i, '');
      accordion.content.append(currentQuestion);
      questionCount += 1;
    });

    if (!questionCount) accordion.content.classList.remove('zhu-product-faq');
    return accordion.details;
  };

  const takeFixedContent = (root, key) => {
    const holder = root.querySelector(`[data-zhu-fixed-content="${key}"]`);
    return holder ? Array.from(holder.children) : [];
  };

  const convertSpecificationTables = (content) => {
    content.querySelectorAll('table').forEach((table) => {
      const list = document.createElement('ul');
      list.className = 'zhu-product-spec-list';

      table.querySelectorAll('tr').forEach((row) => {
        const cells = Array.from(row.querySelectorAll('th, td'));
        if (cells.length < 2) return;

        const label = cells[0].textContent.trim().replace(/\s*:\s*$/, '');
        const value = cells.slice(1).map((cell) => cell.textContent.trim()).filter(Boolean).join(' ');
        if (!label || !value) return;

        const item = document.createElement('li');
        const name = document.createElement('strong');
        name.textContent = `${label}:`;
        item.append(name, document.createTextNode(` ${value}`));
        list.append(item);
      });

      if (list.children.length) table.replaceWith(list);
    });
  };

  const initialise = (root) => {
    if (!mobileQuery.matches || root.dataset.zhuProductDetailsReady === 'true') return;
    const source = root.querySelector('[data-zhu-product-details-source]');
    if (!source) return;

    const groups = { description: [], why: [], specifications: [], faq: [] };
    let active = 'description';

    Array.from(source.children).forEach((node) => {
      if (node.matches('hr')) return;
      if (isHeading(node)) {
        const category = categoryFromHeading(node.textContent);
        if (category === 'why-tips') {
          active = 'why';
          node.classList.add('zhu-product-details__subheading');
          groups.why.push(node);
          return;
        }
        if (category) {
          active = category;
          return;
        }
      }
      if (active !== 'skip') groups[active]?.push(node);
    });

    const rendered = document.createElement('div');
    rendered.className = 'zhu-product-details__rendered';

    if (groups.description.length) rendered.append(createDescription(groups.description));
    if (groups.why.length) {
      const accordion = createAccordion({ key: 'why', title: '¿Por qué elegir este producto?' });
      moveNodes(groups.why, accordion.content);
      rendered.append(accordion.details);
    }
    if (groups.specifications.length) {
      const accordion = createAccordion({ key: 'specifications', title: 'Especificaciones' });
      moveNodes(groups.specifications, accordion.content);
      convertSpecificationTables(accordion.content);
      rendered.append(accordion.details);
    }
    if (groups.faq.length) rendered.append(createFaq(groups.faq));

    const shipping = takeFixedContent(root, 'shipping');
    if (shipping.length) {
      const accordion = createAccordion({ key: 'shipping', title: 'Envíos, tarifas y retiro' });
      moveNodes(shipping, accordion.content);
      rendered.append(accordion.details);
    }
    const payments = takeFixedContent(root, 'payments');
    if (payments.length) {
      const accordion = createAccordion({ key: 'payments', title: 'Medios de pago' });
      moveNodes(payments, accordion.content);
      rendered.append(accordion.details);
    }

    root.querySelector('[data-zhu-product-details-fixed]')?.remove();
    source.remove();
    root.prepend(rendered);
    root.classList.add('zhu-product-details--enhanced');
    root.dataset.zhuProductDetailsReady = 'true';
  };

  const initialiseAll = (scope = document) => scope.querySelectorAll?.('[data-zhu-product-details]').forEach(initialise);
  document.addEventListener('DOMContentLoaded', () => initialiseAll());
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  if (document.readyState !== 'loading') initialiseAll();
})();
